import _definePage_default_0 from '/app/src/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/src/pages/admin-settings/[[category]]/[[section]].vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/app/src/pages/administrative/[[tab]].vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/app/src/pages/administrative/assistant/[[step]].vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/app/src/pages/analytics.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/app/src/pages/auth/invitation.[id].vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/app/src/pages/auth/itero-integration.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/app/src/pages/auth/login.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/app/src/pages/auth/reset-password.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/app/src/pages/auth/reset-password.confirm.[uid].[token].vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/app/src/pages/auth/sso/callback.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/app/src/pages/billing/index.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/app/src/pages/billing/general.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/app/src/pages/billing/intervals.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/app/src/pages/billing/invoices.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from '/app/src/pages/billing/payment-methods.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from '/app/src/pages/billing/payouts.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/app/src/pages/billing/transactions.vue?definePage&vue&lang.tsx'
import _definePage_default_19 from '/app/src/pages/companies/[id].[[tab]].vue?definePage&vue&lang.tsx'
import _definePage_default_20 from '/app/src/pages/companies/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from '/app/src/pages/companies/add.vue?definePage&vue&lang.tsx'
import _definePage_default_22 from '/app/src/pages/companies/ortho-pc/[id]/index.vue?definePage&vue&lang.tsx'
import _definePage_default_23 from '/app/src/pages/companies/ortho-pc/[id]/edit.vue?definePage&vue&lang.tsx'
import _definePage_default_24 from '/app/src/pages/companies/ortho-pc/add.vue?definePage&vue&lang.tsx'
import _definePage_default_25 from '/app/src/pages/contracts/[id]/edit.vue?definePage&vue&lang.tsx'
import _definePage_default_26 from '/app/src/pages/contracts/add.vue?definePage&vue&lang.tsx'
import _definePage_default_27 from '/app/src/pages/cooperation/accept-invite/[id]/complete.vue?definePage&vue&lang.tsx'
import _definePage_default_28 from '/app/src/pages/cooperation/accept-invite/[id]/register.vue?definePage&vue&lang.tsx'
import _definePage_default_29 from '/app/src/pages/cooperation/case-room.vue?definePage&vue&lang.tsx'
import _definePage_default_30 from '/app/src/pages/cooperation/case-room.[id].vue?definePage&vue&lang.tsx'
import _definePage_default_31 from '/app/src/pages/dashboard/all-patients.vue?definePage&vue&lang.tsx'
import _definePage_default_32 from '/app/src/pages/dashboard/co-treatment.vue?definePage&vue&lang.tsx'
import _definePage_default_33 from '/app/src/pages/dashboard/referrals.vue?definePage&vue&lang.tsx'
import _definePage_default_34 from '/app/src/pages/documents/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_35 from '/app/src/pages/guardians/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_36 from '/app/src/pages/invitation.[id].vue?definePage&vue&lang.tsx'
import _definePage_default_37 from '/app/src/pages/invite/error.vue?definePage&vue&lang.tsx'
import _definePage_default_38 from '/app/src/pages/invite/register/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_39 from '/app/src/pages/invite/respond/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_40 from '/app/src/pages/meeting/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_41 from '/app/src/pages/msos/[id]/index.vue?definePage&vue&lang.tsx'
import _definePage_default_42 from '/app/src/pages/msos/[id]/edit.vue?definePage&vue&lang.tsx'
import _definePage_default_43 from '/app/src/pages/msos/[id]/representative.vue?definePage&vue&lang.tsx'
import _definePage_default_44 from '/app/src/pages/msos/[id]/team.vue?definePage&vue&lang.tsx'
import _definePage_default_45 from '/app/src/pages/msos/add.vue?definePage&vue&lang.tsx'
import _definePage_default_46 from '/app/src/pages/next-visit-instructions/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_47 from '/app/src/pages/next-visit-instructions/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_48 from '/app/src/pages/notificationsCenter.vue?definePage&vue&lang.tsx'
import _definePage_default_49 from '/app/src/pages/organization/index.vue?definePage&vue&lang.tsx'
import _definePage_default_50 from '/app/src/pages/organization/dso.vue?definePage&vue&lang.tsx'
import _definePage_default_51 from '/app/src/pages/organization/dso-representative.vue?definePage&vue&lang.tsx'
import _definePage_default_52 from '/app/src/pages/organization/offices.vue?definePage&vue&lang.tsx'
import _definePage_default_53 from '/app/src/pages/organization/practices.vue?definePage&vue&lang.tsx'
import _definePage_default_54 from '/app/src/pages/organization/team.vue?definePage&vue&lang.tsx'
import _definePage_default_55 from '/app/src/pages/ortNeeds/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_56 from '/app/src/pages/ortNeeds/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_57 from '/app/src/pages/ortNeeds/add.vue?definePage&vue&lang.tsx'
import _definePage_default_58 from '/app/src/pages/ortProposedPlan/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_59 from '/app/src/pages/ortProposedPlan/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_60 from '/app/src/pages/ortProposedPlan/add.vue?definePage&vue&lang.tsx'
import _definePage_default_61 from '/app/src/pages/patient-qr/index.vue?definePage&vue&lang.tsx'
import _definePage_default_62 from '/app/src/pages/patient-qr/invalid.vue?definePage&vue&lang.tsx'
import _definePage_default_63 from '/app/src/pages/patient-qr/thank-you.vue?definePage&vue&lang.tsx'
import _definePage_default_64 from '/app/src/pages/patient-questionnaire/index.vue?definePage&vue&lang.tsx'
import _definePage_default_65 from '/app/src/pages/patients/[id].aligner-delivery-instructions.add.vue?definePage&vue&lang.tsx'
import _definePage_default_66 from '/app/src/pages/patients/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_67 from '/app/src/pages/patients/[id].final-debond-instructions.add.vue?definePage&vue&lang.tsx'
import _definePage_default_68 from '/app/src/pages/patients/[id].financing.add.vue?definePage&vue&lang.tsx'
import _definePage_default_69 from '/app/src/pages/patients/[id].guardian.add.vue?definePage&vue&lang.tsx'
import _definePage_default_70 from '/app/src/pages/patients/[id].next-visit-instructions-v2.add.vue?definePage&vue&lang.tsx'
import _definePage_default_71 from '/app/src/pages/patients/[id].next-visit-instructions.add.vue?definePage&vue&lang.tsx'
import _definePage_default_72 from '/app/src/pages/patients/[id].order-aligners.add.vue?definePage&vue&lang.tsx'
import _definePage_default_73 from '/app/src/pages/patients/add.vue?definePage&vue&lang.tsx'
import _definePage_default_74 from '/app/src/pages/practice-staff/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_75 from '/app/src/pages/practice-staff/add.vue?definePage&vue&lang.tsx'
import _definePage_default_76 from '/app/src/pages/practices/[id].[[tab]].vue?definePage&vue&lang.tsx'
import _definePage_default_77 from '/app/src/pages/practices/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_78 from '/app/src/pages/practices/add.vue?definePage&vue&lang.tsx'
import _definePage_default_79 from '/app/src/pages/privacy-policy/index.vue?definePage&vue&lang.tsx'
import _definePage_default_80 from '/app/src/pages/rooms/index.vue?definePage&vue&lang.tsx'
import _definePage_default_81 from '/app/src/pages/rooms/invites/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_82 from '/app/src/pages/rooms/patient/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_83 from '/app/src/pages/scheduling/index.vue?definePage&vue&lang.tsx'
import _definePage_default_84 from '/app/src/pages/settings/[[tab]].vue?definePage&vue&lang.tsx'
import _definePage_default_85 from '/app/src/pages/sso/[slug].vue?definePage&vue&lang.tsx'
import _definePage_default_86 from '/app/src/pages/stl-viewer/[ids].vue?definePage&vue&lang.tsx'
import _definePage_default_87 from '/app/src/pages/terms-and-conditions/index.vue?definePage&vue&lang.tsx'
import _definePage_default_88 from '/app/src/pages/visit-instructions/aligner-delivery/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_89 from '/app/src/pages/visit-instructions/aligner-delivery/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_90 from '/app/src/pages/visit-instructions/aligner-delivery/[id].results.vue?definePage&vue&lang.tsx'
import _definePage_default_91 from '/app/src/pages/visit-instructions/final-debond/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_92 from '/app/src/pages/visit-instructions/final-debond/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_93 from '/app/src/pages/visit-instructions/final-debond/[id].results.vue?definePage&vue&lang.tsx'
import _definePage_default_94 from '/app/src/pages/visit-instructions/next/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_95 from '/app/src/pages/visit-instructions/next/[id].edit.vue?definePage&vue&lang.tsx'
import _definePage_default_96 from '/app/src/pages/visit-instructions/next/[id].results.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: '/',
      component: () => import('/app/src/pages/index.vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  {
    path: '/admin-settings',
    /* internal name: '/admin-settings' */
    /* no component */
    children: [
      {
        path: '',
        name: '/admin-settings/',
        component: () => import('/app/src/pages/admin-settings/index.vue'),
        /* no children */
      },
      {
        path: ':category?',
        /* internal name: '/admin-settings/[[category]]' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':section?',
              name: '/admin-settings/[[category]]/[[section]]',
              component: () => import('/app/src/pages/admin-settings/[[category]]/[[section]].vue'),
              /* no children */
            },
            _definePage_default_2
          )
        ],
      }
    ],
  },
  {
    path: '/administrative',
    /* internal name: '/administrative' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':tab?',
          name: '/administrative/[[tab]]',
          component: () => import('/app/src/pages/administrative/[[tab]].vue'),
          /* no children */
        },
        _definePage_default_3
      ),
      {
        path: 'assistant',
        /* internal name: '/administrative/assistant' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':step?',
              name: '/administrative/assistant/[[step]]',
              component: () => import('/app/src/pages/administrative/assistant/[[step]].vue'),
              /* no children */
            },
            _definePage_default_4
          )
        ],
      }
    ],
  },
  _mergeRouteRecord(
    {
      path: '/analytics',
      name: '/analytics',
      component: () => import('/app/src/pages/analytics.vue'),
      /* no children */
    },
    _definePage_default_5
  ),
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'invitation/:id',
          name: '/auth/invitation.[id]',
          component: () => import('/app/src/pages/auth/invitation.[id].vue'),
          /* no children */
        },
        _definePage_default_6
      ),
      _mergeRouteRecord(
        {
          path: 'itero-integration',
          name: 'itero-integration',
          component: () => import('/app/src/pages/auth/itero-integration.vue'),
          /* no children */
        },
        _definePage_default_7
      ),
      _mergeRouteRecord(
        {
          path: 'login',
          name: 'login',
          component: () => import('/app/src/pages/auth/login.vue'),
          /* no children */
        },
        _definePage_default_8
      ),
      _mergeRouteRecord(
        {
          path: 'reset-password',
          name: '/auth/reset-password',
          component: () => import('/app/src/pages/auth/reset-password.vue'),
          /* no children */
        },
        _definePage_default_9
      ),
      _mergeRouteRecord(
        {
          path: 'reset-password/confirm/:uid/:token',
          name: '/auth/reset-password.confirm.[uid].[token]',
          component: () => import('/app/src/pages/auth/reset-password.confirm.[uid].[token].vue'),
          /* no children */
        },
        _definePage_default_10
      ),
      {
        path: 'sso',
        /* internal name: '/auth/sso' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: 'callback',
              name: '/auth/sso/callback',
              component: () => import('/app/src/pages/auth/sso/callback.vue'),
              /* no children */
            },
            _definePage_default_11
          )
        ],
      }
    ],
  },
  {
    path: '/billing',
    /* internal name: '/billing' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/billing/',
          component: () => import('/app/src/pages/billing/index.vue'),
          /* no children */
        },
        _definePage_default_12
      ),
      _mergeRouteRecord(
        {
          path: 'general',
          name: '/billing/general',
          component: () => import('/app/src/pages/billing/general.vue'),
          /* no children */
        },
        _definePage_default_13
      ),
      _mergeRouteRecord(
        {
          path: 'intervals',
          name: '/billing/intervals',
          component: () => import('/app/src/pages/billing/intervals.vue'),
          /* no children */
        },
        _definePage_default_14
      ),
      _mergeRouteRecord(
        {
          path: 'invoices',
          name: '/billing/invoices',
          component: () => import('/app/src/pages/billing/invoices.vue'),
          /* no children */
        },
        _definePage_default_15
      ),
      _mergeRouteRecord(
        {
          path: 'payment-methods',
          name: '/billing/payment-methods',
          component: () => import('/app/src/pages/billing/payment-methods.vue'),
          /* no children */
        },
        _definePage_default_16
      ),
      _mergeRouteRecord(
        {
          path: 'payouts',
          name: '/billing/payouts',
          component: () => import('/app/src/pages/billing/payouts.vue'),
          /* no children */
        },
        _definePage_default_17
      ),
      _mergeRouteRecord(
        {
          path: 'transactions',
          name: '/billing/transactions',
          component: () => import('/app/src/pages/billing/transactions.vue'),
          /* no children */
        },
        _definePage_default_18
      )
    ],
  },
  {
    path: '/companies',
    /* internal name: '/companies' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id/:tab?',
          name: '/companies/[id].[[tab]]',
          component: () => import('/app/src/pages/companies/[id].[[tab]].vue'),
          /* no children */
        },
        _definePage_default_19
      ),
      _mergeRouteRecord(
        {
          path: ':id/edit',
          name: '/companies/[id].edit',
          component: () => import('/app/src/pages/companies/[id].edit.vue'),
          /* no children */
        },
        _definePage_default_20
      ),
      _mergeRouteRecord(
        {
          path: 'add',
          name: '/companies/add',
          component: () => import('/app/src/pages/companies/add.vue'),
          /* no children */
        },
        _definePage_default_21
      ),
      {
        path: 'ortho-pc',
        /* internal name: '/companies/ortho-pc' */
        /* no component */
        children: [
          {
            path: ':id',
            /* internal name: '/companies/ortho-pc/[id]' */
            /* no component */
            children: [
              _mergeRouteRecord(
                {
                  path: '',
                  name: '/companies/ortho-pc/[id]/',
                  component: () => import('/app/src/pages/companies/ortho-pc/[id]/index.vue'),
                  /* no children */
                },
                _definePage_default_22
              ),
              _mergeRouteRecord(
                {
                  path: 'edit',
                  name: '/companies/ortho-pc/[id]/edit',
                  component: () => import('/app/src/pages/companies/ortho-pc/[id]/edit.vue'),
                  /* no children */
                },
                _definePage_default_23
              )
            ],
          },
          _mergeRouteRecord(
            {
              path: 'add',
              name: '/companies/ortho-pc/add',
              component: () => import('/app/src/pages/companies/ortho-pc/add.vue'),
              /* no children */
            },
            _definePage_default_24
          )
        ],
      }
    ],
  },
  {
    path: '/contracts',
    /* internal name: '/contracts' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: '/contracts/[id]' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: 'edit',
              name: '/contracts/[id]/edit',
              component: () => import('/app/src/pages/contracts/[id]/edit.vue'),
              /* no children */
            },
            _definePage_default_25
          )
        ],
      },
      _mergeRouteRecord(
        {
          path: 'add',
          name: '/contracts/add',
          component: () => import('/app/src/pages/contracts/add.vue'),
          /* no children */
        },
        _definePage_default_26
      )
    ],
  },
  {
    path: '/cooperation',
    /* internal name: '/cooperation' */
    /* no component */
    children: [
      {
        path: 'accept-invite',
        /* internal name: '/cooperation/accept-invite' */
        /* no component */
        children: [
          {
            path: ':id',
            /* internal name: '/cooperation/accept-invite/[id]' */
            /* no component */
            children: [
              _mergeRouteRecord(
                {
                  path: 'complete',
                  name: '/cooperation/accept-invite/[id]/complete',
                  component: () => import('/app/src/pages/cooperation/accept-invite/[id]/complete.vue'),
                  /* no children */
                },
                _definePage_default_27
              ),
              _mergeRouteRecord(
                {
                  path: 'register',
                  name: '/cooperation/accept-invite/[id]/register',
                  component: () => import('/app/src/pages/cooperation/accept-invite/[id]/register.vue'),
                  /* no children */
                },
                _definePage_default_28
              )
            ],
          }
        ],
      },
      _mergeRouteRecord(
        {
          path: 'case-room',
          name: '/cooperation/case-room',
          component: () => import('/app/src/pages/cooperation/case-room.vue'),
          /* no children */
        },
        _definePage_default_29
      ),
      _mergeRouteRecord(
        {
          path: 'case-room/:id',
          name: '/cooperation/case-room.[id]',
          component: () => import('/app/src/pages/cooperation/case-room.[id].vue'),
          /* no children */
        },
        _definePage_default_30
      )
    ],
  },
  {
    path: '/dashboard',
    /* internal name: '/dashboard' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'all-patients',
          name: '/dashboard/all-patients',
          component: () => import('/app/src/pages/dashboard/all-patients.vue'),
          /* no children */
        },
        _definePage_default_31
      ),
      _mergeRouteRecord(
        {
          path: 'co-treatment',
          name: '/dashboard/co-treatment',
          component: () => import('/app/src/pages/dashboard/co-treatment.vue'),
          /* no children */
        },
        _definePage_default_32
      ),
      _mergeRouteRecord(
        {
          path: 'referrals',
          name: '/dashboard/referrals',
          component: () => import('/app/src/pages/dashboard/referrals.vue'),
          /* no children */
        },
        _definePage_default_33
      )
    ],
  },
  {
    path: '/documents',
    /* internal name: '/documents' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id',
          name: '/documents/[id]',
          component: () => import('/app/src/pages/documents/[id].vue'),
          /* no children */
        },
        _definePage_default_34
      )
    ],
  },
  {
    path: '/guardians',
    /* internal name: '/guardians' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id/edit',
          name: '/guardians/[id].edit',
          component: () => import('/app/src/pages/guardians/[id].edit.vue'),
          /* no children */
        },
        _definePage_default_35
      )
    ],
  },
  _mergeRouteRecord(
    {
      path: '/invitation/:id',
      name: '/invitation.[id]',
      component: () => import('/app/src/pages/invitation.[id].vue'),
      /* no children */
    },
    _definePage_default_36
  ),
  {
    path: '/invite',
    /* internal name: '/invite' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'error',
          name: '/invite/error',
          component: () => import('/app/src/pages/invite/error.vue'),
          /* no children */
        },
        _definePage_default_37
      ),
      {
        path: 'register',
        /* internal name: '/invite/register' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/invite/register/[id]',
              component: () => import('/app/src/pages/invite/register/[id].vue'),
              /* no children */
            },
            _definePage_default_38
          )
        ],
      },
      {
        path: 'respond',
        /* internal name: '/invite/respond' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/invite/respond/[id]',
              component: () => import('/app/src/pages/invite/respond/[id].vue'),
              /* no children */
            },
            _definePage_default_39
          )
        ],
      }
    ],
  },
  {
    path: '/meeting',
    /* internal name: '/meeting' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id',
          name: '/meeting/[id]',
          component: () => import('/app/src/pages/meeting/[id].vue'),
          /* no children */
        },
        _definePage_default_40
      )
    ],
  },
  {
    path: '/msos',
    /* internal name: '/msos' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: '/msos/[id]' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/msos/[id]/',
              component: () => import('/app/src/pages/msos/[id]/index.vue'),
              /* no children */
            },
            _definePage_default_41
          ),
          _mergeRouteRecord(
            {
              path: 'edit',
              name: '/msos/[id]/edit',
              component: () => import('/app/src/pages/msos/[id]/edit.vue'),
              /* no children */
            },
            _definePage_default_42
          ),
          _mergeRouteRecord(
            {
              path: 'representative',
              name: '/msos/[id]/representative',
              component: () => import('/app/src/pages/msos/[id]/representative.vue'),
              /* no children */
            },
            _definePage_default_43
          ),
          _mergeRouteRecord(
            {
              path: 'team',
              name: '/msos/[id]/team',
              component: () => import('/app/src/pages/msos/[id]/team.vue'),
              /* no children */
            },
            _definePage_default_44
          )
        ],
      },
      _mergeRouteRecord(
        {
          path: 'add',
          name: '/msos/add',
          component: () => import('/app/src/pages/msos/add.vue'),
          /* no children */
        },
        _definePage_default_45
      )
    ],
  },
  {
    path: '/next-visit-instructions',
    /* internal name: '/next-visit-instructions' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id',
          name: '/next-visit-instructions/[id]',
          component: () => import('/app/src/pages/next-visit-instructions/[id].vue'),
          /* no children */
        },
        _definePage_default_46
      ),
      _mergeRouteRecord(
        {
          path: ':id/edit',
          name: '/next-visit-instructions/[id].edit',
          component: () => import('/app/src/pages/next-visit-instructions/[id].edit.vue'),
          /* no children */
        },
        _definePage_default_47
      )
    ],
  },
  _mergeRouteRecord(
    {
      path: '/notificationsCenter',
      name: '/notificationsCenter',
      component: () => import('/app/src/pages/notificationsCenter.vue'),
      /* no children */
    },
    _definePage_default_48
  ),
  {
    path: '/organization',
    /* internal name: '/organization' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/organization/',
          component: () => import('/app/src/pages/organization/index.vue'),
          /* no children */
        },
        _definePage_default_49
      ),
      _mergeRouteRecord(
        {
          path: 'dso',
          name: '/organization/dso',
          component: () => import('/app/src/pages/organization/dso.vue'),
          /* no children */
        },
        _definePage_default_50
      ),
      _mergeRouteRecord(
        {
          path: 'dso-representative',
          name: '/organization/dso-representative',
          component: () => import('/app/src/pages/organization/dso-representative.vue'),
          /* no children */
        },
        _definePage_default_51
      ),
      _mergeRouteRecord(
        {
          path: 'offices',
          name: '/organization/offices',
          component: () => import('/app/src/pages/organization/offices.vue'),
          /* no children */
        },
        _definePage_default_52
      ),
      _mergeRouteRecord(
        {
          path: 'practices',
          name: '/organization/practices',
          component: () => import('/app/src/pages/organization/practices.vue'),
          /* no children */
        },
        _definePage_default_53
      ),
      _mergeRouteRecord(
        {
          path: 'team',
          name: '/organization/team',
          component: () => import('/app/src/pages/organization/team.vue'),
          /* no children */
        },
        _definePage_default_54
      )
    ],
  },
  {
    path: '/ortNeeds',
    /* internal name: '/ortNeeds' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id',
          name: '/ortNeeds/[id]',
          component: () => import('/app/src/pages/ortNeeds/[id].vue'),
          /* no children */
        },
        _definePage_default_55
      ),
      _mergeRouteRecord(
        {
          path: ':id/edit',
          name: '/ortNeeds/[id].edit',
          component: () => import('/app/src/pages/ortNeeds/[id].edit.vue'),
          /* no children */
        },
        _definePage_default_56
      ),
      _mergeRouteRecord(
        {
          path: 'add',
          name: '/ortNeeds/add',
          component: () => import('/app/src/pages/ortNeeds/add.vue'),
          /* no children */
        },
        _definePage_default_57
      )
    ],
  },
  {
    path: '/ortProposedPlan',
    /* internal name: '/ortProposedPlan' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id',
          name: '/ortProposedPlan/[id]',
          component: () => import('/app/src/pages/ortProposedPlan/[id].vue'),
          /* no children */
        },
        _definePage_default_58
      ),
      _mergeRouteRecord(
        {
          path: ':id/edit',
          name: '/ortProposedPlan/[id].edit',
          component: () => import('/app/src/pages/ortProposedPlan/[id].edit.vue'),
          /* no children */
        },
        _definePage_default_59
      ),
      _mergeRouteRecord(
        {
          path: 'add',
          name: '/ortProposedPlan/add',
          component: () => import('/app/src/pages/ortProposedPlan/add.vue'),
          /* no children */
        },
        _definePage_default_60
      )
    ],
  },
  {
    path: '/patient-qr',
    /* internal name: '/patient-qr' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/patient-qr/',
          component: () => import('/app/src/pages/patient-qr/index.vue'),
          /* no children */
        },
        _definePage_default_61
      ),
      _mergeRouteRecord(
        {
          path: 'invalid',
          name: '/patient-qr/invalid',
          component: () => import('/app/src/pages/patient-qr/invalid.vue'),
          /* no children */
        },
        _definePage_default_62
      ),
      _mergeRouteRecord(
        {
          path: 'thank-you',
          name: '/patient-qr/thank-you',
          component: () => import('/app/src/pages/patient-qr/thank-you.vue'),
          /* no children */
        },
        _definePage_default_63
      )
    ],
  },
  {
    path: '/patient-questionnaire',
    /* internal name: '/patient-questionnaire' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/patient-questionnaire/',
          component: () => import('/app/src/pages/patient-questionnaire/index.vue'),
          /* no children */
        },
        _definePage_default_64
      )
    ],
  },
  {
    path: '/patients',
    /* internal name: '/patients' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id/aligner-delivery-instructions/add',
          name: '/patients/[id].aligner-delivery-instructions.add',
          component: () => import('/app/src/pages/patients/[id].aligner-delivery-instructions.add.vue'),
          /* no children */
        },
        _definePage_default_65
      ),
      _mergeRouteRecord(
        {
          path: ':id/edit',
          name: '/patients/[id].edit',
          component: () => import('/app/src/pages/patients/[id].edit.vue'),
          /* no children */
        },
        _definePage_default_66
      ),
      _mergeRouteRecord(
        {
          path: ':id/final-debond-instructions/add',
          name: '/patients/[id].final-debond-instructions.add',
          component: () => import('/app/src/pages/patients/[id].final-debond-instructions.add.vue'),
          /* no children */
        },
        _definePage_default_67
      ),
      _mergeRouteRecord(
        {
          path: ':id/financing/add',
          name: '/patients/[id].financing.add',
          component: () => import('/app/src/pages/patients/[id].financing.add.vue'),
          /* no children */
        },
        _definePage_default_68
      ),
      _mergeRouteRecord(
        {
          path: ':id/guardian/add',
          name: '/patients/[id].guardian.add',
          component: () => import('/app/src/pages/patients/[id].guardian.add.vue'),
          /* no children */
        },
        _definePage_default_69
      ),
      _mergeRouteRecord(
        {
          path: ':id/next-visit-instructions-v2/add',
          name: '/patients/[id].next-visit-instructions-v2.add',
          component: () => import('/app/src/pages/patients/[id].next-visit-instructions-v2.add.vue'),
          /* no children */
        },
        _definePage_default_70
      ),
      _mergeRouteRecord(
        {
          path: ':id/next-visit-instructions/add',
          name: '/patients/[id].next-visit-instructions.add',
          component: () => import('/app/src/pages/patients/[id].next-visit-instructions.add.vue'),
          /* no children */
        },
        _definePage_default_71
      ),
      _mergeRouteRecord(
        {
          path: ':id/order-aligners/add',
          name: '/patients/[id].order-aligners.add',
          component: () => import('/app/src/pages/patients/[id].order-aligners.add.vue'),
          /* no children */
        },
        _definePage_default_72
      ),
      _mergeRouteRecord(
        {
          path: 'add',
          name: '/patients/add',
          component: () => import('/app/src/pages/patients/add.vue'),
          /* no children */
        },
        _definePage_default_73
      )
    ],
  },
  {
    path: '/practice-staff',
    /* internal name: '/practice-staff' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id/edit',
          name: '/practice-staff/[id].edit',
          component: () => import('/app/src/pages/practice-staff/[id].edit.vue'),
          /* no children */
        },
        _definePage_default_74
      ),
      _mergeRouteRecord(
        {
          path: 'add',
          name: '/practice-staff/add',
          component: () => import('/app/src/pages/practice-staff/add.vue'),
          /* no children */
        },
        _definePage_default_75
      )
    ],
  },
  {
    path: '/practices',
    /* internal name: '/practices' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id/:tab?',
          name: '/practices/[id].[[tab]]',
          component: () => import('/app/src/pages/practices/[id].[[tab]].vue'),
          /* no children */
        },
        _definePage_default_76
      ),
      _mergeRouteRecord(
        {
          path: ':id/edit',
          name: '/practices/[id].edit',
          component: () => import('/app/src/pages/practices/[id].edit.vue'),
          /* no children */
        },
        _definePage_default_77
      ),
      _mergeRouteRecord(
        {
          path: 'add',
          name: '/practices/add',
          component: () => import('/app/src/pages/practices/add.vue'),
          /* no children */
        },
        _definePage_default_78
      )
    ],
  },
  {
    path: '/privacy-policy',
    /* internal name: '/privacy-policy' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/privacy-policy/',
          component: () => import('/app/src/pages/privacy-policy/index.vue'),
          /* no children */
        },
        _definePage_default_79
      )
    ],
  },
  {
    path: '/rooms',
    /* internal name: '/rooms' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/rooms/',
          component: () => import('/app/src/pages/rooms/index.vue'),
          /* no children */
        },
        _definePage_default_80
      ),
      {
        path: 'invites',
        /* internal name: '/rooms/invites' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/rooms/invites/[id]',
              component: () => import('/app/src/pages/rooms/invites/[id].vue'),
              /* no children */
            },
            _definePage_default_81
          )
        ],
      },
      {
        path: 'patient',
        /* internal name: '/rooms/patient' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/rooms/patient/[id]',
              component: () => import('/app/src/pages/rooms/patient/[id].vue'),
              /* no children */
            },
            _definePage_default_82
          )
        ],
      }
    ],
  },
  {
    path: '/scheduling',
    /* internal name: '/scheduling' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/scheduling/',
          component: () => import('/app/src/pages/scheduling/index.vue'),
          /* no children */
        },
        _definePage_default_83
      )
    ],
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':tab?',
          name: '/settings/[[tab]]',
          component: () => import('/app/src/pages/settings/[[tab]].vue'),
          /* no children */
        },
        _definePage_default_84
      ),
      {
        path: 'editProfile',
        name: '/settings/editProfile',
        component: () => import('/app/src/pages/settings/editProfile.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/sso',
    /* internal name: '/sso' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':slug',
          name: '/sso/[slug]',
          component: () => import('/app/src/pages/sso/[slug].vue'),
          /* no children */
        },
        _definePage_default_85
      )
    ],
  },
  {
    path: '/stl-viewer',
    /* internal name: '/stl-viewer' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':ids',
          name: '/stl-viewer/[ids]',
          component: () => import('/app/src/pages/stl-viewer/[ids].vue'),
          /* no children */
        },
        _definePage_default_86
      )
    ],
  },
  {
    path: '/terms-and-conditions',
    /* internal name: '/terms-and-conditions' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/terms-and-conditions/',
          component: () => import('/app/src/pages/terms-and-conditions/index.vue'),
          /* no children */
        },
        _definePage_default_87
      )
    ],
  },
  {
    path: '/visit-instructions',
    /* internal name: '/visit-instructions' */
    /* no component */
    children: [
      {
        path: 'aligner-delivery',
        /* internal name: '/visit-instructions/aligner-delivery' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/visit-instructions/aligner-delivery/[id]',
              component: () => import('/app/src/pages/visit-instructions/aligner-delivery/[id].vue'),
              /* no children */
            },
            _definePage_default_88
          ),
          _mergeRouteRecord(
            {
              path: ':id/edit',
              name: '/visit-instructions/aligner-delivery/[id].edit',
              component: () => import('/app/src/pages/visit-instructions/aligner-delivery/[id].edit.vue'),
              /* no children */
            },
            _definePage_default_89
          ),
          _mergeRouteRecord(
            {
              path: ':id/results',
              name: '/visit-instructions/aligner-delivery/[id].results',
              component: () => import('/app/src/pages/visit-instructions/aligner-delivery/[id].results.vue'),
              /* no children */
            },
            _definePage_default_90
          )
        ],
      },
      {
        path: 'final-debond',
        /* internal name: '/visit-instructions/final-debond' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/visit-instructions/final-debond/[id]',
              component: () => import('/app/src/pages/visit-instructions/final-debond/[id].vue'),
              /* no children */
            },
            _definePage_default_91
          ),
          _mergeRouteRecord(
            {
              path: ':id/edit',
              name: '/visit-instructions/final-debond/[id].edit',
              component: () => import('/app/src/pages/visit-instructions/final-debond/[id].edit.vue'),
              /* no children */
            },
            _definePage_default_92
          ),
          _mergeRouteRecord(
            {
              path: ':id/results',
              name: '/visit-instructions/final-debond/[id].results',
              component: () => import('/app/src/pages/visit-instructions/final-debond/[id].results.vue'),
              /* no children */
            },
            _definePage_default_93
          )
        ],
      },
      {
        path: 'next',
        /* internal name: '/visit-instructions/next' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/visit-instructions/next/[id]',
              component: () => import('/app/src/pages/visit-instructions/next/[id].vue'),
              /* no children */
            },
            _definePage_default_94
          ),
          _mergeRouteRecord(
            {
              path: ':id/edit',
              name: '/visit-instructions/next/[id].edit',
              component: () => import('/app/src/pages/visit-instructions/next/[id].edit.vue'),
              /* no children */
            },
            _definePage_default_95
          ),
          _mergeRouteRecord(
            {
              path: ':id/results',
              name: '/visit-instructions/next/[id].results',
              component: () => import('/app/src/pages/visit-instructions/next/[id].results.vue'),
              /* no children */
            },
            _definePage_default_96
          )
        ],
      }
    ],
  },
  {
    path: '/whats-new',
    name: '/whats-new',
    component: () => import('/app/src/pages/whats-new.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

